module.exports = __webpack_public_path__ + "img/map_toilet_2.2b219f23.png";